import { render, staticRenderFns } from "./scroll.vue?vue&type=template&id=b29cf726"
import script from "./scroll.vue?vue&type=script&lang=js"
export * from "./scroll.vue?vue&type=script&lang=js"
import style0 from "./scroll.vue?vue&type=style&index=0&id=b29cf726&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports